export default __webpack_public_path__ + "static/media/ai_face_trackingActive.a111a215.svg";